// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__qhtSJ","diap":"Button_diap__4iMmw","outline":"Button_outline__NAlwk","arrow":"Button_arrow__fCLxc"};